module.exports = __webpack_public_path__ + "intro.f8a087c0.svg";